/**
 * On Range Bunker Play Reducers
 */
import {
    ORTBUNKER_ACTION,
    ALL_ORTBUNKER,
    ADD_ORTBUNKER,
    FETCH_ORTBUNKER,
    EDIT_ORTBUNKER,
    DELETE_ORTBUNKER,
    FETCH_ORTBUNKERCHART,
    FETCH_ORTBUNKERSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortbunkerlist:[],
    particularortbunker:[],   
    ortbunkerchart:[],
    ortbunkershotchart:[], 
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTBUNKER_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTBUNKER:
            return { ...state, loading: false, ortbunkerlist: action.payload };     
            
        case ADD_ORTBUNKER:
            return { ...state, loading: false };     
         
        case FETCH_ORTBUNKER:
            return { ...state, loading: false, particularortbunker: action.payload };  
            
        case EDIT_ORTBUNKER:
            return { ...state, loading: false }; 
            
        case DELETE_ORTBUNKER:
            return { ...state, loading: false };            
        
        case FETCH_ORTBUNKERCHART:
            return { ...state, loading: false, ortbunkerchart: action.payload }; 

        case FETCH_ORTBUNKERSHOTCHART:
            return { ...state, loading: false, ortbunkershotchart: action.payload }; 
        default: return { ...state };

     }
 }